import {Carousel, Image} from 'antd';
import logo from '../../../assets/mikeric_logo.png';
import React from 'react';
import useFlicker, {Sizes} from '../../../hooks/useFlickr';
import {HomeRoutes} from '../HomeRouter';
import {Link} from 'react-router-dom';
import Loader from '../../../components/Loader';
import Indicator from '../../../components/Indicator';
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

const Logo = () => {
  const breakpoint = useBreakpoint();

  return (
          <Image
                  alt={'Mike Eric Logo'}
                  className={'filter drop-shadow'}
                  style={{width: breakpoint.lg ? '256px' : '128px', height: 'auto'}}
                  src={logo}
                  preview={false}
          />
  )
};

const CarouselImages = ({images}) => {
  if (!images.length) {
    return null;
  }

  return images.map((image, i) => (
            <img
                    key={i}
                    className={'aspect-square lg:aspect-[16/9] object-top object-cover'}
                    src={image.getSize({sizeLabel: Sizes.large}).source}
                    alt=""
            />
  ));
}

const Hero = () => {
  const {images: flickrImages, isLoading: isLoadingImages} = useFlicker({
    photosetId: '72177720327552986'
  });
  const breakpoint = useBreakpoint();

  return (
          <div className={'relative aspect-square lg:aspect-[16/9] bg-gray-800'}>
            {isLoadingImages && <Loader indicator={<Indicator color={'#fff'}/>} absolute fullHeight fullWidth/>}
            <div className={`absolute w-full h-full transition-opacity duration-1000 ease-out ${isLoadingImages ? 'opacity-0' : 'opacity-1'}`}>
              <Carousel>
                {CarouselImages({images: flickrImages})}
              </Carousel>
            </div>
            <div className={`absolute p-16 md:p-32 transition-opacity duration-2000 delay-500 ease-out ${isLoadingImages ? 'opacity-0' : 'opacity-1'} ${breakpoint.lg ? '' : 'right-0 bottom-0'}`}>
              <Link to={HomeRoutes.index()}><Logo/></Link>
            </div>
          </div>
  );
};

export default Hero;
